import React from 'react';

import Badge from 'common/uiV3/Badge';

import type { IdeaStatus } from 'common/api/resources/statuses';
import type { ColorValues } from 'common/colors/constants';

type Props = {
  status: IdeaStatus;
};

const IdeaStatusPill = ({ status }: Props) => {
  return (
    <Badge
      style={{
        color: status.color as ColorValues,
        background: `${status.color}20` as ColorValues,
        textTransform: 'capitalize',
      }}>
      {status.name}
    </Badge>
  );
};

export default IdeaStatusPill;
